import React, { PropsWithChildren } from 'react';

import ErrorInspector from '@/components/shared/ErrorInspector';
import { useTestEnrichMutation } from '@/graphql';
import { FetchError } from '@/graphql/codegen-fetcher';
import {
	Button,
	ButtonGroup,
	FormControl,
	FormLabel,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Stack,
	Textarea,
} from '@chakra-ui/react';
import { Formik } from 'formik';
import * as yup from 'yup';

const enrichTagInputSchema = yup.object({
	text: yup.string().defined(),
});

const FormSectionTitle: React.FC<PropsWithChildren> = ({ children }) => (
	<FormLabel mt={10} fontWeight={800} fontSize={18}>
		{children}
	</FormLabel>
);

const initialValues: {
	text: string;
} = {
	text: '',
};

export type CreateRecordInitialValues = typeof initialValues;

type TestEnrichModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const TestEnrichModal: React.FC<TestEnrichModalProps> = ({
	isOpen,
	onClose,
}) => {
	const { mutateAsync, data } = useTestEnrichMutation<FetchError>();

	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Test Enrich</ModalHeader>
				<ModalCloseButton />
				<Formik
					key="asaphSignUn"
					initialValues={initialValues}
					validationSchema={enrichTagInputSchema}
					onSubmit={async (values, formikHelpers) => {
						try {
							await mutateAsync({
								text: values.text,
							});
						} catch (err) {
							console.error(err);
						} finally {
							formikHelpers.setSubmitting(false);
						}
					}}
				>
					{({
						submitForm,
						handleSubmit,
						handleChange,
						values,
						errors,
						setFieldValue,
					}) => {
						return (
							<form onSubmit={handleSubmit}>
								<ModalBody>
									<FormControl>
										<Stack spacing={4}>
											<FormSectionTitle>
												Enrich tag details
											</FormSectionTitle>

											<FormControl isRequired>
												<FormLabel>Text</FormLabel>
												<Textarea
													placeholder="text"
													name="text"
													onChange={handleChange}
													value={values.text}
												/>
											</FormControl>
										</Stack>
									</FormControl>

									<ErrorInspector
										JSON={{
											form: errors,
											request: data,
										}}
									/>
								</ModalBody>
								<ModalFooter>
									<ButtonGroup w="100%" spacing={2}>
										<Button
											onClick={submitForm}
											type="submit"
										>
											Test
										</Button>
									</ButtonGroup>
								</ModalFooter>
							</form>
						);
					}}
				</Formik>
			</ModalContent>
		</Modal>
	);
};

export default TestEnrichModal;
